import { render } from "./PlatFormSetting.vue?vue&type=template&id=610aadfa"
import script from "./PlatFormSetting.vue?vue&type=script&lang=js"
export * from "./PlatFormSetting.vue?vue&type=script&lang=js"

import "./PlatFormSetting.vue?vue&type=style&index=0&id=610aadfa&lang=scss&Scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__